import { render, staticRenderFns } from "./FeaturedNewsNav.vue?vue&type=template&id=009e24c8&"
import script from "./FeaturedNewsNav.vue?vue&type=script&lang=js&"
export * from "./FeaturedNewsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports